'use client';

import { DataTable } from '@/components/ui/data-table';
import { RealtimeOrder, useOrderStore } from '@/stores/orderStore';
import { ColumnDef } from '@tanstack/react-table';
import { FormatDistanceLocale, formatDistanceToNow, formatDistanceToNowStrict } from 'date-fns';

const columns: ColumnDef<RealtimeOrder>[] = [
  {
    header: 'Hash',
    accessorKey: 'hash',
    cell: ({ row }) => {
      return (
        <span className='text-[#D6F8D6]'>
          {row.original.txHash.slice(0, 6) + '...' + row.original.txHash.slice(-4)}
        </span>
      );
    },
  },
  {
    header: 'Action',
    accessorKey: 'Action',
    cell: ({ row }) => {
      return <span className='capitalize'>{row.original.side}</span>;
    },
  },
  {
    header: 'Block',
    accessorKey: 'block',
    cell: ({ row }) => {
      return <span className='text-[#D6F8D6]'>{row.original.blockHeight}</span>;
    },
  },
  {
    header: 'Time',
    accessorKey: 'time',
    cell: ({ row }) => {
      return formatDistanceToNowStrict(row.original.timestamp, {
        addSuffix: true,
      });
    },
  },
  {
    header: 'User',
    accessorKey: 'user',
    cell: ({ row }) => {
      return (
        <span className='text-[#D6F8D6]'>
          {row.original.orderId.slice(0, 6) + '...' + row.original.orderId.slice(-4)}
        </span>
      );
    },
  },
];

export default function NewOrderDataTable() {
  const realtimeOrders = useOrderStore(state => {
    return state.realtimeOrders;
  });

  return (
    <div className='flex-1'>
      <DataTable
        data={realtimeOrders}
        columns={columns}
        tableTitle='Latest Transactions'
      />
    </div>
  );
}
